module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0032.jpg?v=ae42d711";